"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports["default"] = {
    expiryDays: 0,
    openFuturePeriods: 0,
    timelyDays: 15
};
module.exports = exports["default"];
//# sourceMappingURL=dataSet.js.map


//////////////////
// WEBPACK FOOTER
// ./~/d2/lib/model/config/model-defaults/dataSet.js
// module id = 418
// module chunks = 0